<template>
  <SettingsPagePanelHeader>
    <template #title>利用状況</template>
  </SettingsPagePanelHeader>
</template>

<script setup lang="ts">
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
</script>
